import { AfterViewInit, Component, computed, inject, OnInit } from '@angular/core';
import { ActionButtonsComponent } from "../edit-route/components/action-buttons/action-buttons.component";
import { BannerInfoComponent } from './components/banner-info/banner-info.component';
import { EditInfoComponent } from "./components/edit-info/edit-info.component";
import { TranslateModule } from '@ngx-translate/core';
import { LocalStorageService } from 'src/app/services/localStorage.service';
import { PointsComponent } from "./components/points/points.component";
import { ScrollService } from 'src/app/services/scroll.service';
import { EditRouteService } from './services/edit-route.service';
import { editedCustomRouteAdapter } from './adapters/edited-custom-route.adapter';
import { CustomRouteService } from 'src/app/pages/custom-route/services/custom-route.service';
import { PlannerViewsStateService } from '../../services';

@Component({
  selector: 'app-edit-route',
  standalone: true,
  imports: [
    TranslateModule,
    ActionButtonsComponent,
    BannerInfoComponent,
    EditInfoComponent,
    PointsComponent
],
  templateUrl: './edit-route.component.html',
  styleUrls: ['./edit-route.component.scss'],
})
export class EditRouteComponent implements OnInit, AfterViewInit {  
  private _customRouteService = inject(CustomRouteService);
  private _editRouteService = inject(EditRouteService);
  private _localStorageService = inject(LocalStorageService);
  private _scrollService = inject(ScrollService);
  private _plannerViewStateService = inject(PlannerViewsStateService);
  
  private readonly _customRouteData = computed(() => this._customRouteService.customRouteData());
  private readonly _customRouteEditedDataToRender = computed(() => this._editRouteService.customRouteEditedDataToRender());

  public showBanner: boolean = true;
  public showEditInfo = this._localStorageService.getItem<boolean>('showEditInfo') ?? true;
  
  ngOnInit(): void {
    this._plannerViewStateService.isEditRouteView.set(true);
    
    // initialize custom route edited data to send adapting the custom route data
    const editedCustomRouteAdapted = editedCustomRouteAdapter(this._customRouteData()); 
    this._editRouteService.customRouteEditedDataToSend.set(editedCustomRouteAdapted);
    
    // initialize custom route edited data to render with the same data
    this._editRouteService.customRouteEditedDataToRender.set(this._editRouteService.customRouteEditedDataToSend());
    
    // initilize initial state custom route edited data to render to check if there are changes (Update button state)
    this._editRouteService.initialStateCustomRouteEditedDataToRender.set(this._customRouteEditedDataToRender())
    
    // set isScrolled to false due to the actions affected by the scroll is only for the planner view
    this._scrollService.isScrolled.set(false);
  }
  
  ngAfterViewInit(): void {
    const el: HTMLElement = document.querySelector('app-planner');
    if (!el) return;
    
    this._scrollService.autoScrollToTop(el);
  }
  
  public closeBanner() {
    this.showBanner = false;
  }
  
  public closeEditInfo() {
    this.showEditInfo = false;
  }
  
  public openEditInfo() {
    this.showEditInfo = true;
  }
  
  public gotItEditInfo() {
    this.showEditInfo = false;
    this._localStorageService.setItem('showEditInfo', false);
  }
  
  ngOnDestroy(): void {
    this._plannerViewStateService.isEditRouteView.set(false);
  }
}
